export const highResVideoDimensions = {
  height: 720,
  width: 1280,
}

export const lowResVideoDimensions = {
  height: 240,
  width: 320,
}
